import { useState } from 'react';
import { useNotification } from '../../../../contexts/NotificationContext';

export const INVENTORY_FORM_INITIAL_STATE = {
  product_name: '',
  hospital_id: 1,
  quantity: '',
  price: '',
};

export const useInventoryForm = (initialData = INVENTORY_FORM_INITIAL_STATE) => {
  const { showNotification } = useNotification();
  const [formData, setFormData] = useState(initialData);
  const [errors, setErrors] = useState({});

  const setInitialData = (dataOrUpdater) => setFormData(dataOrUpdater);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Max length guards
    if (name === 'quantity' && value.length > 3) return;
    if (name === 'price' && value.length > 6) return;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = '';
    switch (name) {
      case 'product_name':
        if (!value.trim()) error = 'Product name is required';
        else if (value.trim().length < 2) error = 'Product name must be at least 2 characters';
        break;
      case 'quantity':
        if (!value) error = 'Quantity is required';
        else if (Number(value) <= 0) error = 'Quantity must be positive';
        else if (Number(value) > 999) error = 'Quantity cannot exceed 999';
        break;
      case 'price':
        if (!value) error = 'Price is required';
        else if (Number(value) <= 0) error = 'Price must be positive';
        else if (Number(value) > 999999) error = 'Price cannot exceed 999,999';
        break;
      default: break;
    }
    if (error) setErrors(prev => ({ ...prev, [name]: error }));
  };

  const validate = () => {
    const temp = {};
    if (!formData.product_name?.trim()) temp.product_name = 'Product name is required';
    else if (formData.product_name.trim().length < 2) temp.product_name = 'Product name must be at least 2 characters';
    if (!formData.quantity) temp.quantity = 'Quantity is required';
    else if (Number(formData.quantity) <= 0) temp.quantity = 'Quantity must be a positive number';
    else if (Number(formData.quantity) > 999) temp.quantity = 'Quantity cannot exceed 999';
    if (!formData.price) temp.price = 'Price is required';
    else if (Number(formData.price) <= 0) temp.price = 'Price must be a positive number';
    else if (Number(formData.price) > 999999) temp.price = 'Price cannot exceed 999,999';

    setErrors(temp);
    if (Object.keys(temp).length > 0) {
      showNotification('error', `Required Field: ${Object.values(temp)[0]}`);
      return false;
    }
    return true;
  };

  return { formData, errors, setInitialData, handleChange, handleBlur, validate };
};
